/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export const MANUFACTURES = ["BIOTRONIK", "BOSTONSCI", "MEDTRONIC", "STJUDE", "BIOTEL", "OTHER"];
export const LEAD_STATUS = ["IMPLANTED", "EXPLANTED", "ABANDONED"];
export const LEAD_TYPES = ["LV", "RA", "RV", "OTHER", "SUBCUTANEOUS", "HIS", "UNKNOWN"];
